const DocumentModule = {
  EMPLOYEE_DOCUMENTS: "EMPLOYEE_DOCUMENTS",
  LEAVE_DOCUMENTS: "LEAVE_DOCUMENTS",
};

export default DocumentModule;
